import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "container", "button"];

  connect() {
    this.update();
  }

  update() {
    const option = this.selectTarget.selectedOptions[0];
    const prompt = option?.dataset.prompt || "";
    this.containerTarget.textContent = prompt;
    this.buttonTarget.hidden = prompt === "";
  }
}
